import React, { useEffect, useState } from "react";
import { Box, Button, Image, Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Text } from "@chakra-ui/react";
import { fetchChatImage } from "../services/api";
export function ChatImage({ attachmentId, ownerId }: { attachmentId: string; ownerId?: string }) {
  const [url, setUrl] = useState<string>();
  const [unavailable, setUnavailable] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let active = true; let objectUrl: string | undefined;
    setUrl(undefined); setUnavailable(false); setOpen(false);
    fetchChatImage(attachmentId).then(blob => {
      if (active) { objectUrl = URL.createObjectURL(blob); setUrl(objectUrl); }
    }).catch(() => { if (active) setUnavailable(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachmentId, ownerId]);
  if (unavailable) return <Text role="status">Image unavailable</Text>;
  if (!url) return <Text role="status">Loading image…</Text>;
  return <Box mb={2}>
    <Button variant="unstyled" height="auto" onClick={() => setOpen(true)} aria-label="Open shared image">
      <Image src={url} alt="Image shared in this conversation" maxH="240px" maxW="100%" objectFit="contain" borderRadius="md" />
    </Button>
    <Modal isOpen={open} onClose={() => setOpen(false)} size="4xl" isCentered>
      <ModalOverlay /><ModalContent><ModalCloseButton aria-label="Close image" /><ModalBody p={8}>
        <Image src={url} alt="Larger shared image" maxH="80vh" objectFit="contain" mx="auto" />
      </ModalBody></ModalContent>
    </Modal>
  </Box>;
}
